import React from "react";

import { FilePreviewProps } from "../Preview.props";

export const FilePreviewAudio: React.FC<FilePreviewProps> = ({ url }) => (
  <audio controls src={url} style={{ width: "100%" }} />
);
